export default __webpack_public_path__ + "static/media/B13.249f2877.png";